import { Box, Typography, Grid, TextField, InputLabel, Button, FormControl, Autocomplete     } from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { useClassification } from '../../../../shared/context/classificactionContext'
import { useEffect } from 'react'
import { useLocations } from '../../../../shared/context/locationsContext'
import { useInsumo } from '../../../../shared/context/insumoContext'
import LocationOnIcon from '@mui/icons-material/LocationOn';
export default function FilterInsumoComponent({ type_asset }) {
    const { getClassification, classifications } = useClassification()
    const { getLocations, locations, getLocationsOptions, locationsOptions  } = useLocations()

    const { getInsumos, insumos, setFiltersData } = useInsumo()

    const getSavedFormValues = () => {
        const savedForm = localStorage.getItem(`insumo_filter_${type_asset}`)
        if (savedForm) {
            try {
                return JSON.parse(savedForm)
            } catch (e) {
                console.error("Error parsing saved form data", e)
            }
        }
        return {
            name: "",
            type_insumo: "",
            date_entry: "",
            location: [],
            code: "",
            classification1: [],
            classification2: [],
        }
    }

    const { setValue, handleSubmit, control, reset, watch } = useForm({
        defaultValues: getSavedFormValues()
    })

    const formValues = watch()
    useEffect(() => {
        localStorage.setItem(`insumo_filter_${type_asset}`, JSON.stringify(formValues))
    }, [formValues, type_asset])


   

  

    useEffect(() => {
        getLocationsOptions()
    }, [])



    const onSubmit = (data) => {
        setFiltersData(data)
        getInsumos(data)
    }

    const handleClearForm = () => {
        reset()
        const defaultValues = {
            name: "",
            type_insumo: "",
            date_entry: "",
            location: [],
            code: "",
            classification1: [],
            classification2: [],
        }
        Object.keys(defaultValues).forEach(key => {
            setValue(key, defaultValues[key]);
        });
        setFiltersData({})
        localStorage.removeItem(`insumo_filter_${type_asset}`);
        getInsumos()
    }

    const handleInputChange = (key, newValue) => {
        setValue(key, newValue)
    }

    return (
        <Box sx={{ padding: 2 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} columns={12}>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Nombre</InputLabel>
                    <Controller
                        control={control}
                        name="name"
                        fullWidth
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                name="name"
                                value={field.value}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

               

                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Tipo de Insumo</InputLabel>
                    <Controller
                        control={control}
                        name="type_insumo"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                name="type_insumo"
                                value={field.value}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Fecha de Entrada</InputLabel>
                    <Controller
                        control={control}
                        name="date_entry"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                name="date_entry"
                                type="date"
                                value={field.value}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Ubicación</InputLabel>
                    <Controller
                        control={control}
                        name="location"
                        render={({ field }) => (
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    disablePortal={false}
                                    options={locationsOptions || []}
                                    getOptionLabel={(option) => option?.name || ""}
                                    onInputChange={(_, newValue) => {
                                        getLocationsOptions({ name: newValue })
                                    }}
                                    value={locationsOptions ? locationsOptions.filter(c => field.value.includes(c.id)) : []}
                                    onChange={(_, newValue) => {
                                        handleInputChange(field.name, newValue.map(item => item.id));
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params}  />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <LocationOnIcon sx={{ color: 'primary.main', mr: 1 }} fontSize="small" />
                                            {option.name}
                                        </Box>
                                        </li>
                                    )}
                                    
                                />
                            </FormControl>
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Código</InputLabel>
                    <Controller
                        control={control}
                        name="code"
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                name="code"
                                value={field.value}
                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Clasificación 1</InputLabel>
                    <Controller
                        control={control}
                        name="classification1"
                        render={({ field }) => (
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    disablePortal={false}
                                    options={classifications || []}
                                    getOptionLabel={(option) => option?.value || ""}
                                    onOpen={() => {
                                        getClassification({ type_asset, number: 1 })
                                    }}
                                    value={classifications ? classifications.filter(c => field.value.includes(c.id)) : []}
                                    onChange={(_, newValue) => {
                                        handleInputChange(field.name, newValue.map(item => item.id));
                                    }}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField {...params} 
                                            fullWidth
                                            onChange={(e) => {
                                                getClassification({ type_asset, number: 1, search: e.target.value });
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option?.value}
                                        </li>
                                    )}
                                />
                            </FormControl>
                        )}
                    /> 
                </Grid>

                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Clasificación 2</InputLabel>
                    <Controller
                        control={control}
                        name="classification2"
                        render={({ field }) => (
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    disablePortal={false}
                                    options={classifications || []}
                                    getOptionLabel={(option) => option?.value || ""}
                                    onOpen={() => {
                                        getClassification({ type_asset, number: 2 })
                                    }}
                                    value={classifications ? classifications.filter(c => field.value.includes(c.id)) : []}
                                    onChange={(_, newValue) => {
                                        handleInputChange(field.name, newValue.map(item => item.id));
                                    }}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField {...params} 
                                            fullWidth
                                            onChange={(e) => {
                                                getClassification({ type_asset, number: 2, search: e.target.value });
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option?.value}
                                        </li>
                                    )}
                                />
                            </FormControl>
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <Button type="submit" variant="contained" color="primary" fullWidth size="large"
                    sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600 }}>Buscar</Button>
                    <Button 
                        variant="contained" 
                        color="disabled" 
                        fullWidth 
                        size="large"
                        onClick={handleClearForm}
                        sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600, mt: "5px" }}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
            </form>
        </Box>
    )
}